


































































import Vue from 'vue';
import Component from 'vue-class-component';

import '../globals';
import { Settings, LANGUAGE } from '@/models/settings';

@Component
export default class SettingsPage extends Vue {

    public async languageChanged(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        Vue.set(this.$store.settings, 'language', value);

        // activate language in VueI18n
        this.$i18n.locale = value;

        // update map and turn off favorit check
        this.$store.mapShowFavorites = false;
        this.$store.mapChangeSourceRequest = true;

        this.$ga.event({
            eventCategory: 'settings',
            eventAction: 'languageChanged',
            eventLabel: value
        });

        const success = await this.$store.saveState();
        if (success) {
            this.$store.forceReload();
        }
    }

    public async highAccuracyLocationChanged(event: Event) {
        const value = (event.target as HTMLInputElement).checked;
        Vue.set(this.$store.settings, 'highAccuracyLocation', value);
        await this.$store.saveState();

        this.$ga.event({
            eventCategory: 'settings',
            eventAction: 'highAccuracyChanged',
            eventLabel: value,
        });
    }

    private openSettings() {
        // TODO open native location settings
        // ios "prefs:root=LOCATION_SERVICES"
        // android ?? eventuell muessen wir hier ueber unity gehen
        alert('OpenSettings (not implemented)');
    }
}
